module.exports = __webpack_public_path__ + "logo-dark.png?c41665692ef17b26eed6514c64a2e458";


//////////////////
// WEBPACK FOOTER
// ./images/logo-dark.png
// module id = 7
// module chunks = 0